module.exports = __webpack_public_path__ + "static/media/KV03.c6b4fe9f.jpg";